import slider from './components/slider.js'
import tabs from './components/tabs.js'
import modal from './components/modal.js'
import validate from './components/validate.js'
